export var defaultImageCardDimensions = {
  width: 156,
  height: 125
};